/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_NoteInputs */

const en_road_dude_prompt_note = /** @type {(inputs: Road_Dude_Prompt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The generator opens with the selected prompt. Add your own reference photo before submitting.`)
};

const zh_road_dude_prompt_note = /** @type {(inputs: Road_Dude_Prompt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`所选提示词会自动填入生成器。提交前请上传自己的参考照片。`)
};

/**
* | output |
* | --- |
* | "The generator opens with the selected prompt. Add your own reference photo before submitting." |
*
* @param {Road_Dude_Prompt_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_note = /** @type {((inputs?: Road_Dude_Prompt_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_note(inputs)
	return zh_road_dude_prompt_note(inputs)
});
export { road_dude_prompt_note as "road_dude.prompt.note" }